<script lang="ts">
    import Fieldset from "../Form/Fieldset.svelte";
    import Input from "../Form/Input.svelte";
    import Select from "../Form/Select.svelte";
    import Textarea from "../Form/Textarea.svelte";
    import Modal from "../Modal/Modal.svelte";
    import {ApiCall} from "../../services/ApiCall.ts";
    import {orderSchema} from "../../validationsForm/orderValidation.ts";
    import {push, link} from "svelte-spa-router";

    type Order = {
        interlocuteur: string,
        ref_chantier: string,
        phone: string,
        address: string,
        address_supplement: string,
        postal_code: string,
        city: string,
        cubage: number,
        planning: string,
        planning_remarque: string,
        longueur_tuyaux_chape: number,
        longueur_tuyaux_eau: number,
        acces: string,
        acces_remarque: string,
        plancher: string,
        plancher_remarque: string,
        chape: string,
        fibree: string
    };

    const accessDifficulties:string[] = ['facile', 'moyen', 'difficile'];
    const allScreed:string[] = ['ANHYDRITE', 'CIMENT C16', 'CIMENT C20', 'RAVOIRAGE CIMENT', 'RAVOIRAGE ANHYDRITE', 'ANHYDRITE PREMIUM', 'C25 P4S', 'C25 P4R'];
    const floorType:string[] = ['CHAUFFANT A EAU', 'CHAUFFANT ELECTRIQUE', 'CHAUFFANT REVERSIBLE', 'BETON SANS ISOLANT', 'BETON AVEC ISOLANT', 'AUTRE'];
    let floorPrecision: boolean = false
    let area:number;
    let thickness:number;
    let planning: string;
    let planning_hour: string;
    let submitted = false;

    let order:Order = {
        interlocuteur: '',
        ref_chantier: '',
        phone: '',
        address: '',
        address_supplement: '',
        postal_code: '',
        city: '',
        cubage: 0,
        planning: '',
        planning_remarque: '',
        longueur_tuyaux_chape: 0,
        longueur_tuyaux_eau: 0,
        acces: '',
        acces_remarque: '',
        plancher: '',
        plancher_remarque: '',
        chape: '',
        fibree: ''
    };

    function floorTypeCheck() {
        let choice = (<HTMLSelectElement>document.getElementById("floor")).value;
        floorPrecision = choice === 'AUTRE';
    }

    let promise;
    let errors = {};
    async function orderValidation() {

        order.cubage = parseFloat((<HTMLInputElement>(document.getElementById('cubage'))).value);
        order.planning = planning + ' ' + planning_hour + ':00';

        try {
            await orderSchema.validate(order, {abortEarly: false});
            errors = {};

            promise = makeApiCall();
        }
        catch (err) {
            const allFieldset = <HTMLLegendElement>document.getElementsByClassName('fieldset-legend');
            for (const fieldsetElement of allFieldset) {
               if (!fieldsetElement.classList.contains('fieldset-legend--active')){
                   fieldsetElement.click();
               }
            }

            errors = err.inner.reduce((acc, err) => {
                return ( { ...acc, [err.path]: err.message });
            }, {});
        }
    }

    let orderStatus:boolean = false;
    let orderError:boolean = false;
     async function makeApiCall() {

         const apiCall = new ApiCall();

         try{
             const content = await apiCall.authenticatedPostRequest('applicateur/store_commande', order);

             if (content.success === false) {
                 orderError = true;
             }
             else{
                 orderStatus = true;

                 let form = document.getElementById('order-form') as HTMLFormElement;
                 form.reset();
             }
         }
         catch (e) {
             push('/erreur500')
         }
     }
</script>

<h2 class="title is-2 has-text-centered mb-6">Nouvelle commande</h2>
{#await promise}
    <div>
        <Modal title="Commande en cours" type="loader"/>
    </div>
{/await}
{#if orderError}
    <div>
        <Modal title="Erreur lors de la commande" type="error" message="La commande à échouée, veuillez réessayer.">
            <svelte:fragment slot="button">
                <button on:click={() => {orderError = false}} class="modal-close is-large" aria-label="close"></button>
            </svelte:fragment>
        </Modal>
    </div>
{/if}
{#if orderStatus}
    <div>
        <Modal title="Commande réussie" type="validation">
            <svelte:fragment slot="button">
                <button on:click={() => {orderStatus = false}} class="modal-close is-large" aria-label="close"></button>
            </svelte:fragment>
            <svelte:fragment slot="buttons-container">
                <button on:click={() => {orderStatus = false}} class="button-close button is-info">Fermer</button>
                <a href="/compte/commande" use:link class="button is-info">Voir mes commandes</a>
            </svelte:fragment>
        </Modal>
    </div>
{/if}

<form id="order-form" class:submitted on:submit|preventDefault={orderValidation}>
    <Fieldset name="Informations de commande" logo="RAPPELS.png">
        <svelte:fragment slot="slot1">
            <Input bind:value={order.interlocuteur} label="Interlocuteur*" name="interlocutor" placeholder="Veuillez saisir un interlocuteur sur le chantier" type="text" error={errors.interlocuteur} />
        </svelte:fragment>
        <svelte:fragment slot="slot2">
            <Input bind:value={order.phone} label="Téléphone*" name="phone" placeholder="Veuillez saisir un numéro de téléphone pour l'interlocuteur" type="text" error={errors.phone} />
        </svelte:fragment>
        <svelte:fragment slot="slot3">
            <Input bind:value={order.ref_chantier} label="Référence chantier" name="reference" placeholder="Veuillez saisir votre référence chantier" error={errors.ref_chantier} type="text"/>
        </svelte:fragment>
    </Fieldset>

    <Fieldset name="Adresse du chantier" logo="CASQUE.png">
        <svelte:fragment slot="slot1">
            <Input bind:value={order.address} label="Numéro et Nom de la voie" name="adress" placeholder="Veuillez saisir l'adresse du chantier" error={errors.address} type="text"/>
        </svelte:fragment>
        <svelte:fragment slot="slot2">
            <Input bind:value={order.address_supplement} label="Complément d'Adresse" name="adress" placeholder="Veuillez saisir le complément de l'adresse" error={errors.address_supplement} type="text"/>
        </svelte:fragment>
        <svelte:fragment slot="slot3">
            <Input bind:value={order.postal_code} label="Code Postal" name="code" placeholder="Veuillez saisir le code postal du chantier" error={errors.postal_code} type="number"/>
        </svelte:fragment>
        <svelte:fragment slot="slot4">
            <Input bind:value={order.city} label="Ville*" name="city" placeholder="Veuillez saisir la ville du chantier" error={errors.city} type="text" />
        </svelte:fragment>
        <svelte:fragment slot="additional-fields">
            <div class="is-flex-desktop is-flex-direction-row is-justify-content-space-between columns is-desktop">
                <div class="column is-12 is-6-desktop">
                    <Select bind:value={order.acces} label="Difficulté sur l'accès*" name="access" allOptions={accessDifficulties} error={errors.acces} />
                </div>
                <div class=" column is-12 is-6-desktop">
                    <Textarea bind:value={order.acces_remarque} label="Commentaire sur l'accès" name="access-comment" placeholder="Veuillez saisir des précisions sur l'accès si nécessaire" error={errors.acces_remarque}/>
                </div>
            </div>
        </svelte:fragment>
    </Fieldset>

    <Fieldset name="Informations du chantier" logo="CHAPE.png" info="<p class='has-text-centered pb-4'><strong>Pensez à valider la disponibilité de nos camions pour votre livraison en appelant le planning au <a href='tel:0380370505'>03 80 37 05 05</a></strong></p>">
        <svelte:fragment slot="slot1">
            <Input bind:value={planning} label="Date*" name="planning" type="date" placeholder="jj/mm/aaaa" error={errors.planning} />
        </svelte:fragment>
        <svelte:fragment slot="slot2">
            <Input bind:value={planning_hour} label="Heure de coulage*" name="planning_hour" type="time" placeholder="HH:mm" />
        </svelte:fragment>
        <svelte:fragment slot="slot3">
            <Textarea bind:value={order.planning_remarque} label="Précision sur la date et l'heure souhaité" name="planning_comment" placeholder="Veuillez saisir des précisions sur la date et l'heure souhaitez si nécessaire" error={errors.planning_remarque} />
        </svelte:fragment>
        <svelte:fragment slot="additional-fields">
            <div class="is-flex-desktop is-flex-direction-row is-justify-content-space-between columns is-desktop">
                <div class="column is-12 is-6-desktop">
                    <Select bind:value={order.chape} label="Chape*" name="screed" allOptions={allScreed} error={errors.chape} />
                </div>
                <div class="column is-12 is-6-desktop">
                    <label class="label" for="fiber">Fibrée*</label>
                    <div class="control">
                        <label class="radio"><input bind:group={order.fibree} id="fiber" class="mr-2" type="radio" name="fiber" value="true" >Oui</label>
                        <label class="radio"><input bind:group={order.fibree} class="mr-2" type="radio" name="fiber" value="false">Non</label>
                    </div>
                    {#if errors.fibree}
                        <p class="help is-danger">{errors.fibree}</p>
                    {/if}
                </div>
            </div>
            <div class="is-flex-desktop is-flex-direction-row is-justify-content-space-between columns is-desktop">
                <div class="column is-12 is-6-desktop">
                    <Select on:change={floorTypeCheck} bind:value={order.plancher} label="Type de plancher*" name="floor" allOptions={floorType} error={errors.plancher} />
                </div>
                {#if floorPrecision}
                    <div class=" column is-12 is-6-desktop">
                        <Textarea bind:value={order.plancher_remarque} label="Précision sur la nature du plancher" name="floor-description" placeholder="Veuillez saisir des précisions sur la nature du plancher" error={errors.plancher_remarque}/>
                    </div>
                {/if}
            </div>
            <div class="is-flex-desktop is-flex-direction-row is-justify-content-space-between columns is-desktop">
                <div class="column is-12 is-6-desktop">
                    <Input bind:value={order.longueur_tuyaux_chape} label="Longueur de tuyaux pour la chape en ml" name="screed_pipes_length" placeholder="Veuillez saisir le nombre de ml de tuyaux nécessaire" type="number" error={errors.longueur_tuyaux_chape}/>
                </div>
                <div class="column is-12 is-6-desktop">
                    <Input bind:value={order.longueur_tuyaux_eau} label="Longueur de tuyaux d'eau en ml" placeholder="Veuillez saisir le nombre de ml de tuyaux nécessaire" name="water_pipes_length" type="number" error={errors.longueur_tuyaux_eau} />
                </div>
            </div>
            <p class="label has-text-centered ">Calculez ou saisissez directement votre cubage</p>
            <div class="is-flex-desktop is-flex-direction-row columns is-desktop">
                <div class="column is-12 is-3-desktop">
                    <Input bind:value={area} label="Surface en m²" name="area" placeholder="Veuillez saisir un surface" type="number" step="0.1"/>
                </div>
                <div class="column is-12 is-1-desktop is-flex is-justify-content-center">
                    <p class="calcul-operator has-text-weight-bold">X</p>
                </div>
                <div class="column is-12 is-3-desktop">
                    <Input bind:value={thickness} label="Épaisseur en cm" name="thickness" placeholder="Veuillez saisir une épaisseur" type="number" step="0.1"/>
                </div>
                <div class="column is-12 is-1-desktop is-flex is-justify-content-center">
                    <p class="calcul-operator has-text-weight-bold">=</p>
                </div>
                <div class="column is-12 is-4-desktop">
                    <Input value={(area * thickness * 0.01).toFixed(1)} label="Cubage souhaité en m³*" name="cubage" placeholder="Veuillez saisir le cubage" type="number" step="0.1" error={errors.cubage} />
                </div>
            </div>
        </svelte:fragment>
    </Fieldset>

    <div class="field pt-3">
        <div class="control is-flex is-justify-content-center">
            <button class="button is-success" type="submit" on:click={() => submitted = true}>Commander</button>
        </div>
    </div>
</form>